export default "__VITE_ASSET__BlcPQqnn__"